<div class="voice-recorder-section">
  <div class="voice-recorder-indicator" (click)="toggle()" [class.is-recording]="isRecording()">
    @if (isRecording()) {
      <div class="voice-halo" [style.transform]="'scale(' + haloScale() + ')'" [style.opacity]="haloOpacity()"></div>
    }
    <button type="button" mat-fab class="voice-mic-btn" [class.recording]="isRecording()">
      <mat-icon class="icon-filled">{{ isRecording() ? 'stop' : 'mic' }}</mat-icon>
    </button>
  </div>
  <span class="voice-label" [class.active]="isRecording()">
    {{ isRecording() ? ('ContentGenerator.StopRecording' | translate) : ('ContentGenerator.RecordVoiceNote' | translate) }}
  </span>

  @if (!isRecording()) {
    <div class="mic-selector-container w-full max-w-[240px] mt-2">
      @if (microphonePermissionState() === 'prompt') {
        <button mat-button type="button" (click)="requestPermission()" class="w-full flex items-center justify-center gap-2">
          <mat-icon>mic</mat-icon>
          <span>{{ 'DeviceSelector.AuthorizeMic' | translate }}</span>
        </button>
      } @else {
        <app-device-selector [kind]="'audioinput'" [hideIcon]="true" [label]="'DeviceSelector.MicrophoneLabel'" (selectionChange)="onMicrophoneSelected($event)"></app-device-selector>
      }
    </div>
  }
</div>
